import { createFileRoute, redirect } from "@tanstack/react-router"

import { redirectToLanding } from "@/app/landing"
import { optionalSession } from "@/app/optional-session"
import { lastOrganisation } from "@/lib/last-organisation"

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const session = await optionalSession(context.queryClient)
    const remembered = lastOrganisation()

    if (session) {
      redirectToLanding(session, remembered)
    }

    if (remembered) {
      throw redirect({
        to: "/$organisation",
        params: { organisation: remembered },
      })
    }

    throw redirect({ to: "/login" })
  },
})
